// Renderer jalan isometrik — LOGIKA EKSAK "Full Asphalt + Edge Check".
// Aspal 100% penuh per tile, trotoar di sisi luar, marka putih putus-putus,
// kuning ganda di sambungan 2-tile, zebra cross di ujung jalan menuju persimpangan.
import { TILE_W, TILE_H } from "./iso";

// ---- drawRoadTile: logika eksak per-tile ----
export function drawRoadTile(ctx, gx, gy, cx, cy, TW, TH, isRoadAt, poles, waterSet) {
  // Titik sudut belah ketupat tile (N, E, S, W)
  const N = { x: cx, y: cy - TH / 2 };
  const E = { x: cx + TW / 2, y: cy };
  const S = { x: cx, y: cy + TH / 2 };
  const W = { x: cx - TW / 2, y: cy };
  // Cek 4 tetangga di grid
  // Sisi NE (Atas-Kanan: gy-1), SE (Bawah-Kanan: gx+1), SW (Bawah-Kiri: gy+1), NW (Atas-Kiri: gx-1)
  const nNE = isRoadAt(gx, gy - 1);
  const nSE = isRoadAt(gx + 1, gy);
  const nSW = isRoadAt(gx, gy + 1);
  const nNW = isRoadAt(gx - 1, gy);
  // 1. GAMBAR ASPAL PENUH 100% TILE — JUGA di atas air (jembatan tetap
  //    menampilkan permukaan jalan raya utuh & menerus, jangan terputus).
  ctx.beginPath();
  ctx.moveTo(N.x, N.y);
  ctx.lineTo(E.x, E.y);
  ctx.lineTo(S.x, S.y);
  ctx.lineTo(W.x, W.y);
  ctx.closePath();
  ctx.fillStyle = '#475569';
  ctx.fill();
  ctx.strokeStyle = '#475569';
  ctx.lineWidth = 1;
  ctx.stroke();
  // Helper interpolasi titik untuk trotoar & marka
  const lerp = (p1, p2, t) => ({ x: p1.x + (p2.x - p1.x) * t, y: p1.y + (p2.y - p1.y) * t });
  // 2. GAMBAR TROTOAR HANYA DI SISI YANG BUKAN JALAN (Tebal 16% tile)
  const sw = 0.16;
  const drawSidewalkEdge = (pA, pB, pOppA, pOppB) => {
    const inA = lerp(pA, pOppA, sw);
    const inB = lerp(pB, pOppB, sw);
    ctx.beginPath();
    ctx.moveTo(pA.x, pA.y);
    ctx.lineTo(pB.x, pB.y);
    ctx.lineTo(inB.x, inB.y);
    ctx.lineTo(inA.x, inA.y);
    ctx.closePath();
    ctx.fillStyle = '#CBD5E1';
    ctx.fill();
  };
  if (!nNE) drawSidewalkEdge(N, E, W, S);
  if (!nSW) drawSidewalkEdge(S, W, E, N);
  if (!nNW) drawSidewalkEdge(W, N, S, E);
  if (!nSE) drawSidewalkEdge(E, S, N, W);
  // 3. DETEKSI ARAH JALAN LURUS VS PERSIMPANGAN SEJATI
  // Jalan sepanjang sumbu X (NW ke SE) vs sumbu Y (NE ke SW)
  const alongX = (nNW && nSE) && !(nNE && nSW);
  const alongY = (nNE && nSW) && !(nNW && nSE);
  const isIntersection = (nNW || nSE) && (nNE || nSW) && !(alongX || alongY);
  // Titik tengah 4 sisi
  const midNW = lerp(W, N, 0.5), midSE = lerp(E, S, 0.5);
  const midNE = lerp(N, E, 0.5), midSW = lerp(S, W, 0.5);
  // helper deteksi persimpangan di tile tetangga
  const checkIsIntersection = (tx, ty) => {
    if (!isRoadAt(tx, ty)) return false;
    const aX = isRoadAt(tx - 1, ty) && isRoadAt(tx + 1, ty);
    const aY = isRoadAt(tx, ty - 1) && isRoadAt(tx, ty + 1);
    return aX && aY;
  };
  // 4. MARKA GARIS PUTIH & KUNING GANDA (BERHENTI SEBELUM ZEBRA CROSS)
  // Skala proporsional: ketebalan mengikuti lebar tile di layar (tidak statis),
  // sehingga marka tidak menebal/menumpuk saat zoom out, dan tetap proporsional
  // saat zoom in (rasio dipilih agar sama persis dengan tampilan semula di zoom 1).
  const tileEdgeW = Math.hypot(E.x - N.x, E.y - N.y);
  const zNow = TW / TILE_W;
  const lwWhite = Math.max(0.4, tileEdgeW * 0.028);   // ≈ 2px saat zoom 1
  const lwYellow = Math.max(0.4, tileEdgeW * 0.021);  // ≈ 1.5px saat zoom 1
  ctx.lineCap = 'butt'; // ujung marka tidak membulat/memanjang saat tile menyusut
  const markAlpha = zNow < 0.5 ? 0.75 : 1; // LOD: anti-aliasing tidak memblok saat zoom out ekstrem
  ctx.globalAlpha = markAlpha;
  if (!isIntersection) { // di jembatan pun marka tetap digambar agar jalan menerus
    const isNextToIntersection = checkIsIntersection(gx + 1, gy) || checkIsIntersection(gx - 1, gy) || checkIsIntersection(gx, gy + 1) || checkIsIntersection(gx, gy - 1);
    // Garis putih di tengah tile (pendekkan jika dekat persimpangan agar tidak menabrak zebra cross)
    ctx.strokeStyle = '#FFFFFF';
    ctx.lineWidth = lwWhite;
    if (alongX || ((nNW || nSE) && !alongY)) {
      const p1 = lerp(midNW, midSE, isNextToIntersection ? 0.15 : 0.3);
      const p2 = lerp(midNW, midSE, isNextToIntersection ? 0.55 : 0.7);
      ctx.beginPath(); ctx.moveTo(p1.x, p1.y); ctx.lineTo(p2.x, p2.y); ctx.stroke();
      // Garis kuning ganda (Hanya digambar jika TIDAK sedang di tile persimpangan/dekat zebra cross)
      const drawYellowEdge = (A, B) => {
        ctx.strokeStyle = '#EAB308'; ctx.lineWidth = lwYellow;
        ctx.beginPath(); ctx.moveTo(A.x, A.y); ctx.lineTo(B.x, B.y); ctx.stroke();
      };
      if (!isNextToIntersection) {
        if (nNE && isRoadAt(gx - 1, gy - 1) && isRoadAt(gx + 1, gy - 1)) drawYellowEdge(lerp(N, W, 0.08), lerp(E, S, 0.08));
        if (nSW && isRoadAt(gx - 1, gy + 1) && isRoadAt(gx + 1, gy + 1)) drawYellowEdge(lerp(S, E, 0.08), lerp(W, N, 0.08));
      }
    } else if (alongY || (nNE || nSW)) {
      const p1 = lerp(midNE, midSW, isNextToIntersection ? 0.15 : 0.3);
      const p2 = lerp(midNE, midSW, isNextToIntersection ? 0.55 : 0.7);
      ctx.beginPath(); ctx.moveTo(p1.x, p1.y); ctx.lineTo(p2.x, p2.y); ctx.stroke();
      const drawYellowEdge = (A, B) => {
        ctx.strokeStyle = '#EAB308'; ctx.lineWidth = lwYellow;
        ctx.beginPath(); ctx.moveTo(A.x, A.y); ctx.lineTo(B.x, B.y); ctx.stroke();
      };
      if (!isNextToIntersection) {
        if (nNW && isRoadAt(gx - 1, gy - 1) && isRoadAt(gx - 1, gy + 1)) drawYellowEdge(lerp(W, S, 0.08), lerp(N, E, 0.08));
        if (nSE && isRoadAt(gx + 1, gy - 1) && isRoadAt(gx + 1, gy + 1)) drawYellowEdge(lerp(E, N, 0.08), lerp(S, W, 0.08));
      }
    }
  }
  ctx.globalAlpha = 1; // akhir blok marka — zebra cross di bawah TIDAK diubah
  // 5. ZEBRA CROSS RAPI — strip SEJAJAR lurus (arah konstan, bukan kipas)
  // LOD mengikuti ukuran tile di layar (currentTileWidth = lebar tepi tile):
  //  - dekat (>=35): persis seperti semula (5 strip, lebar 2.5px di zoom 1)
  //  - sedang (<35 & >=18): 4 strip, lebar strip 60% dari normal agar celah tetap terbaca
  //  - jauh (<18): 3 strip tipis + alpha 0.7 agar tidak memblok jadi blok putih tebal
  const drawZebraOnEdge = (edgeA, edgeB, oppA, oppB) => {
    // vektor arah ke dalam (dari tengah bibir ke tengah tile), dinormalisasi
    const cxm = (edgeA.x + edgeB.x) / 2, cym = (edgeA.y + edgeB.y) / 2;
    const cxo = (oppA.x + oppB.x) / 2, cyo = (oppA.y + oppB.y) / 2;
    let dx = cxo - cxm, dy = cyo - cym;
    const dl = Math.hypot(dx, dy) || 1;
    dx /= dl; dy /= dl;
    // LOD berdasarkan currentTileWidth (lebar tepi tile di layar)
    let nStrip, wRatio, alpha;
    if (tileEdgeW >= 35) { nStrip = 5; wRatio = 1; alpha = 1; }          // zoom normal/dekat
    else if (tileEdgeW >= 18) { nStrip = 4; wRatio = 0.6; alpha = 1; }   // zoom out sedang
    else { nStrip = 3; wRatio = 0.6; alpha = 0.7; }                      // zoom out jauh
    // lebar strip murni rasio tile (≈2.5px saat zoom 1), dikalikan wRatio LOD
    ctx.lineWidth = Math.max(0.4, tileEdgeW * 0.0347 * wRatio);
    ctx.lineCap = 'butt';
    ctx.globalAlpha = alpha;
    ctx.strokeStyle = '#FFFFFF';
    const depth = TH * 0.24;      // panjang strip (ke dalam jalan, konstan)
    const off0 = TH * 0.02;       // jarak dari bibir
    // strip SEJAJAR lurus digeser merata sepanjang bibir persimpangan.
    // jarak antar strip mengikuti jumlah strip LOD (span tetap 0.25–0.75 bibir).
    const t0 = 0.25, t1 = 0.75, span = t1 - t0;
    for (let i = 0; i < nStrip; i++) {
      const t = t0 + (nStrip === 1 ? span / 2 : span * i / (nStrip - 1));
      const sx = edgeA.x + (edgeB.x - edgeA.x) * t + dx * off0;
      const sy = edgeA.y + (edgeB.y - edgeA.y) * t + dy * off0;
      ctx.beginPath();
      ctx.moveTo(sx, sy);
      ctx.lineTo(sx + dx * depth, sy + dy * depth);
      ctx.stroke();
    }
    ctx.globalAlpha = 1; // kembalikan selesai menggambar zebra cross
  };
  if (!isIntersection) {
    if (alongX && checkIsIntersection(gx + 1, gy)) drawZebraOnEdge(E, S, W, N);
    if (alongX && checkIsIntersection(gx - 1, gy)) drawZebraOnEdge(W, N, E, S);
    if (alongY && checkIsIntersection(gx, gy + 1)) drawZebraOnEdge(S, W, N, E);
    if (alongY && checkIsIntersection(gx, gy - 1)) drawZebraOnEdge(N, E, S, W);
  }
  // 6. LAMPU JALAN TROTOAR — jarak renggang (tiap 6 tile), 1 tiang per tile,
  //    bukan di persimpangan & bukan di atas jembatan sungai. Tiang digambar
  //    pada PASS KEDUA (setelah semua tile jalan selesai) agar tidak tertutup
  //    aspal tile tetangga.
  if (!isIntersection && !(waterSet && waterSet.has(gx + "," + gy))) {
    const onX = alongX && gx % 6 === 0;
    const onY = alongY && gy % 6 === 0;
    if (onX || onY) {
      // selang-seling sisi trotoar kiri/kanan
      const sideA = (gx + gy) % 2 === 0;
      const edgeMid = onX ? (sideA ? midNE : midSW) : (sideA ? midNW : midSE);
      const center = { x: cx, y: cy };
      // sabuk trotoar abu-abu: sedikit menjorok ke dalam dari tepi luar (0.08)
      const base = lerp(edgeMid, center, 0.08);
      poles.push({ base, center });
    }
  }
}

// ---- Tiang lampu isometrik: alas + tiang vertikal + lengan ke badan jalan ----
// Semua ukuran proporsional terhadap TW/TH (sudah termasuk skala zoom).
function drawStreetLight(ctx, base, center, TW, TH) {
  const poleH = TH * 0.62;
  const poleW = Math.max(0.5, TW * 0.012);
  // alas tiang kecil di permukaan trotoar
  ctx.fillStyle = "#334155";
  ctx.beginPath(); ctx.ellipse(base.x, base.y, TW * 0.018, TH * 0.03, 0, 0, 7); ctx.fill();
  // tiang vertikal ke atas
  const topX = base.x, topY = base.y - poleH;
  ctx.strokeStyle = "#475569";
  ctx.lineWidth = poleW;
  ctx.lineCap = "butt";
  ctx.beginPath(); ctx.moveTo(base.x, base.y); ctx.lineTo(topX, topY); ctx.stroke();
  // lengan pendek menjorok ke arah badan jalan aspal (pusat tile)
  let ax = center.x - base.x, ay = center.y - base.y;
  const al = Math.hypot(ax, ay) || 1;
  const armLen = TW * 0.09;
  const armX = topX + (ax / al) * armLen, armY = topY + (ay / al) * armLen;
  ctx.beginPath(); ctx.moveTo(topX, topY); ctx.lineTo(armX, armY); ctx.stroke();
  // KAP/TUDUNG penutup atas — setengah elips gelap menyatu tiang (siang hari
  // hanya siluet tudung; pijar & cahaya malam digambar di frame() di engine).
  const hw = Math.max(1.6, TW * 0.024);  // setengah lebar kap
  const hh = Math.max(1.0, TH * 0.05);   // tinggi kap pipih
  ctx.fillStyle = "#3A414E";
  ctx.beginPath();
  ctx.ellipse(armX, armY, hw, hh, 0, Math.PI, 0); // setengah atas
  ctx.closePath(); ctx.fill();
  // titik tanah tepat di bawah kepala lampu (untuk kolam cahaya malam)
  return { x: armX, y: armY, px: armX, py: armY + poleH, hw, hh };
}

// ---- JEMBATAN DEK BETON DATAR MENYAMBUNG ("Continuous Flat Deck Bridge") ----
// Permukaan jalan raya (aspal + trotoar + marka) SUDAH digambar utuh per-tile
// oleh drawRoadTile di atas air — fungsi ini HANYA menambah struktur:
//   1. Dinding dek beton (#6C7582) setebal 6–8px skala tile di sisi tepi luar
//      jalan yang menghadap kamera & berbatasan air, + bayangan di permukaan air.
//   2. Pagar railing terang (#DCE2EA): tiang-tiang kecil berderet + 1 palang
//      atas LURUS sejajar kemiringan isometrik 2:1 (menyambung antar-tile).
//      Pagar HANYA di sisi yang berbatasan air — tidak di tengah antar-lajur.
// Urutan: dipanggil SETELAH drawRoadTile agar tampak "di bawah tepian jalan"
// (bagian dek/bayangan menjorok ke bawah tile, ke arah air).
export function drawBridge(ctx, gx, gy, cx, cy, TW, TH, isRoadAt) {
  const nNE = isRoadAt(gx, gy - 1), nSE = isRoadAt(gx + 1, gy);
  const nSW = isRoadAt(gx, gy + 1), nNW = isRoadAt(gx - 1, gy);
  const N = { x: cx, y: cy - TH / 2 };
  const E = { x: cx + TW / 2, y: cy };
  const S = { x: cx, y: cy + TH / 2 };
  const W = { x: cx - TW / 2, y: cy };
  const lerp = (p1, p2, t) => ({ x: p1.x + (p2.x - p1.x) * t, y: p1.y + (p2.y - p1.y) * t });
  // Empat tepi tile + status jalan tetangganya. Tepi tanpa jalan di seberang =
  // tepi luar jembatan (berbatasan air/tanah) — pada tile jembatan ini air.
  const edges = [
    { a: N, b: E, road: nNE }, // NE
    { a: E, b: S, road: nSE }, // SE (menghadap kamera kanan-bawah)
    { a: S, b: W, road: nSW }, // SW (menghadap kamera kiri-bawah)
    { a: W, b: N, road: nNW }, // NW
  ];
  const waterEdges = edges.filter(e => !e.road);
  if (!waterEdges.length) return;
  const deckH = Math.max(3, TH * 0.13);   // tebal dek 6–8px saat zoom 1 (TH=64)
  const railH = Math.max(2.5, TH * 0.1);  // tinggi pagar 5–6px saat zoom 1
  ctx.save();
  // 1. BAYANGAN di permukaan air tepat di bawah sisi dek (efek ketinggian)
  ctx.fillStyle = "rgba(0,0,0,0.28)";
  for (const e of waterEdges) {
    ctx.beginPath();
    ctx.moveTo(e.a.x, e.a.y + deckH);
    ctx.lineTo(e.b.x, e.b.y + deckH);
    const bIn = lerp(e.b, e.a, 0.06), aIn = lerp(e.a, e.b, 0.06);
    ctx.lineTo(bIn.x, bIn.y + deckH + TH * 0.09);
    ctx.lineTo(aIn.x, aIn.y + deckH + TH * 0.09);
    ctx.closePath(); ctx.fill();
  }
  // 2. DINDING DEK BETON — poligon vertikal turun dari tepi luar jalan ke air
  ctx.fillStyle = "#6C7582";
  for (const e of waterEdges) {
    ctx.beginPath();
    ctx.moveTo(e.a.x, e.a.y);
    ctx.lineTo(e.b.x, e.b.y);
    ctx.lineTo(e.b.x, e.b.y + deckH);
    ctx.lineTo(e.a.x, e.a.y + deckH);
    ctx.closePath(); ctx.fill();
    // garis tepi atas dek sedikit lebih terang (bibir beton)
    ctx.strokeStyle = "#8A95A3";
    ctx.lineWidth = Math.max(0.5, TH * 0.02);
    ctx.beginPath(); ctx.moveTo(e.a.x, e.a.y); ctx.lineTo(e.b.x, e.b.y); ctx.stroke();
  }
  // 3. PAGAR RAILING — tiang-tiang kecil terang berderet + 1 palang atas lurus
  for (const e of waterEdges) {
    ctx.strokeStyle = "#DCE2EA";
    ctx.lineWidth = Math.max(0.6, TH * 0.028);
    ctx.lineCap = "butt";
    for (let i = 0; i <= 4; i++) {
      const t = i / 4;
      const b = lerp(e.a, e.b, t);
      ctx.beginPath(); ctx.moveTo(b.x, b.y); ctx.lineTo(b.x, b.y - railH); ctx.stroke();
    }
    // palang pegangan atas: lurus sejajar kemiringan tepi (isometrik 2:1)
    ctx.lineWidth = Math.max(0.8, TH * 0.036);
    ctx.beginPath();
    ctx.moveTo(e.a.x, e.a.y - railH);
    ctx.lineTo(e.b.x, e.b.y - railH);
    ctx.stroke();
  }
  ctx.restore();
}

export function paintRoads(ctx, roadSet, env) { for (const _ of paintRoadsGen(ctx, roadSet, env)) { /* jalankan sampai selesai */ } }

// Versi generator: yield tiap `env.sliceTiles` tile (pass 1) agar engine bisa menyicil build antar-frame
export function* paintRoadsGen(ctx, roadSet, env) {
  if (!roadSet || !roadSet.size) return;
  const { gridToScreen } = env;
  const z = env.zoom || 1;
  const has = (x, y) => roadSet.has(x + "," + y);
  const TW = TILE_W * z, TH = TILE_H * z;
  // Culling: tile yang pusatnya jauh di luar area gambar (env.view = {x0,y0,x1,y1} px layar) dilewati
  const v = env.view, pad = TW * 1.5 + 60 * z;
  const terlihat = (cx, cy) => !v || (cx > v.x0 - pad && cx < v.x1 + pad && cy > v.y0 - pad && cy < v.y1 + pad);
  // Pass 1: gambar semua tile jalan sambil mengumpulkan tiang lampu
  const poles = []; let n = 0;
  for (const key of roadSet) {
    const [gx, gy] = key.split(",").map(Number);
    // pusat tile sebenarnya = gridToScreen(gx+0.5, gy+0.5)
    const [cx, cy] = gridToScreen(gx + 0.5, gy + 0.5);
    if (!terlihat(cx, cy)) continue;
    drawRoadTile(ctx, gx, gy, cx, cy, TW, TH, has, poles, env.waterSet);
    if (env.sliceTiles && ++n % env.sliceTiles === 0) yield;
  }
  // Pass 2: tiang lampu di atas semua jalan yang sudah selesai digambar
  for (const p of poles) {
    const head = drawStreetLight(ctx, p.base, p.center, TW, TH);
    if (env.lamps) env.lamps.push(head);
  }
  // Pass 3: jembatan beton untuk tile jalan yang menimpa sungai (di atas air)
  const wSet = env.waterSet;
  if (wSet && wSet.size) {
    for (const key of roadSet) {
      if (!wSet.has(key)) continue;
      const [gx, gy] = key.split(",").map(Number);
      const [cx, cy] = gridToScreen(gx + 0.5, gy + 0.5);
      if (!terlihat(cx, cy)) continue;
      drawBridge(ctx, gx, gy, cx, cy, TW, TH, has);
    }
  }
}
